(function (window, document) {
  'use strict';

  var apiName = 't4sScrollOverflow';
  var containerSelector = '[data-scroll-overflow]';

  if (window[apiName]) {
    window[apiName].init(document);
    return;
  }

  // 控制drag拖动，防止误触等
  function initDragScroll(track) {
    var dragThreshold = 5;
    var isPointerDown = false;
    var isDragging = false;
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var suppressClick = false;
    var clickResetId = 0;
    var isScrollable = false;
    // 记录初始化状态
    var originalCursor = track.style.cursor;
    var originalUserSelect = track.style.userSelect;
    var originalWebkitUserSelect = track.style.webkitUserSelect;
    var originalScrollSnapType = track.style.scrollSnapType;

    function setScrollable(value) {
      isScrollable = value;

      if (!isPointerDown) {
        track.style.cursor = isScrollable ? 'grab' : originalCursor;
      }
    }

    function beginDrag(clientX, id) {
      if (!isScrollable) return;

      if (clickResetId) {
        window.clearTimeout(clickResetId);
        clickResetId = 0;
      }

      suppressClick = false;
      isPointerDown = true;
      isDragging = false;
      pointerId = id;
      startX = clientX;
      startScrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.userSelect = 'none';
      track.style.webkitUserSelect = 'none';
    }

    function moveDrag(clientX, event) {
      if (!isPointerDown) return;

      var distance = clientX - startX;

      if (!isDragging && Math.abs(distance) < dragThreshold) return;

      if (!isDragging) {
        isDragging = true;
        track.style.scrollSnapType = 'none';

        if (
          pointerId !== null &&
          track.setPointerCapture &&
          !track.hasPointerCapture(pointerId)
        ) {
          track.setPointerCapture(pointerId);
        }
      }

      track.scrollLeft = startScrollLeft - distance;

      if (event.cancelable) {
        event.preventDefault();
      }
    }

    function endDrag() {
      if (!isPointerDown) return;

      var endedPointerId = pointerId;
      var didDrag = isDragging;

      isPointerDown = false;
      isDragging = false;
      pointerId = null;
      track.style.cursor = isScrollable ? 'grab' : originalCursor;
      track.style.userSelect = originalUserSelect;
      track.style.webkitUserSelect = originalWebkitUserSelect;
      // 拖拽完后重置状态
      track.style.scrollSnapType = originalScrollSnapType;

      if (
        endedPointerId !== null &&
        track.releasePointerCapture &&
        track.hasPointerCapture(endedPointerId)
      ) {
        track.releasePointerCapture(endedPointerId);
      }

      if (didDrag) {
        suppressClick = true;
        clickResetId = window.setTimeout(function () {
          suppressClick = false;
          clickResetId = 0;
        }, 0);
      }
    }

    function onPointerDown(event) {
      if (
        event.button !== 0 ||
        event.isPrimary === false ||
        event.pointerType === 'touch'
      ) {
        return;
      }

      beginDrag(event.clientX, event.pointerId);
    }

    function onPointerMove(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;
      moveDrag(event.clientX, event);
    }

    function onPointerEnd(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;
      endDrag();
    }

    function onMouseDown(event) {
      if (event.button !== 0) return;
      beginDrag(event.clientX, 'mouse');
    }

    function onMouseMove(event) {
      if (!isPointerDown) return;
      moveDrag(event.clientX, event);
    }

    track.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );

    track.addEventListener('dragstart', function (event) {
      if (isPointerDown) event.preventDefault();
    });

    if ('PointerEvent' in window) {
      track.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', onPointerEnd);
      window.addEventListener('pointercancel', onPointerEnd);
      track.addEventListener('lostpointercapture', endDrag);
      document.addEventListener('pointerleave', onPointerEnd);
    } else {
      track.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove, { passive: false });
      window.addEventListener('mouseup', endDrag);
      document.addEventListener('mouseleave', endDrag);
    }

    window.addEventListener('blur', endDrag);

    return { setScrollable: setScrollable };
  }

  // 监听滚动条展示
  function initContainer(container) {
    if (!container || container.dataset.scrollOverflowReady === 'true') return;

    var track = container.querySelector('[data-scroll-overflow-track]');
    var indicator = container.querySelector('[data-scroll-overflow-indicator]');

    if (!track || !indicator) return;

    container.dataset.scrollOverflowReady = 'true';

    var frameId = 0;
    var dragScroll = initDragScroll(track);

    function update() {
      frameId = 0;
      var isScrollable = track.scrollWidth > track.clientWidth + 1;
      indicator.hidden = !isScrollable;
      dragScroll.setScrollable(isScrollable);
    }

    function requestUpdate() {
      if (frameId) return;
      frameId = window.requestAnimationFrame(update);
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', requestUpdate, { passive: true });
    }

    if ('MutationObserver' in window) {
      var mutationObserver = new MutationObserver(requestUpdate);
      mutationObserver.observe(track, { childList: true, subtree: true });
    }

    update();
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(containerSelector)) {
      initContainer(scope);
    }

    scope.querySelectorAll(containerSelector).forEach(initContainer);
  }

  window[apiName] = { init: init };
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})(window, document);
